import FolderView from './FolderView';
import './FolderView.scss';

export default FolderView;
